import * as React from "react";
import { UseFormReturn } from "react-hook-form";

import { AccountInfoSection } from "./components/AccountInfoSection";
import { AssignmentsSection } from "./components/AssignmentsSection";
import { PermissionsSection } from "./components/PermissionsSection";
import { NotificationSubscriptionsSection } from "./components/NotificationSubscriptionsSection";
import { AssistantCoach } from "@/services/bedrock/dtos/AssistantCoach";

interface OwnProps {
  form: UseFormReturn<any>;
  coachId: number;
  withWritePermission?: boolean;
  assistant?: AssistantCoach;
}

export const AssistantForm: React.FC<OwnProps> = ({ form, withWritePermission = true, assistant }) => {
  const isSubmitting = form.formState.isSubmitting;
  const isDisabled = !withWritePermission || isSubmitting;

  return (
    <div className="flex flex-col gap-8 w-full p-6 bg-slate-50/50 rounded-2xl">
      {/* Top: Account Information (Full Width Card) */}
      <div className="bg-white border border-slate-200/80 rounded-2xl p-6 shadow-sm hover:shadow-md/20 transition-all duration-200 flex flex-col gap-4 w-full">
        <AccountInfoSection form={form} isDisabled={isDisabled} />
      </div>

      {/* Bottom: 50/50 Split Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 w-full items-start">
        {/* Left Bottom: Assignments & Scoping Card */}
        <div className="bg-white border border-slate-200/80 rounded-2xl p-6 shadow-sm hover:shadow-md/20 transition-all duration-200 flex flex-col gap-4 h-full min-h-[300px]">
          <AssignmentsSection form={form} isDisabled={isDisabled} assistant={assistant} />
        </div>

        {/* Right Bottom: Access / Permissions Matrix Card */}
        <div className="bg-white border border-slate-200/80 rounded-2xl p-6 shadow-sm hover:shadow-md/20 transition-all duration-200 flex flex-col gap-6 h-fit">
          <PermissionsSection form={form} isDisabled={isDisabled} />
        </div>
      </div>

      {/* Notification Preferences (Full Width Card, only shown when editing an existing assistant) */}
      {assistant?.userId && (
        <div className="bg-white border border-slate-200/80 rounded-2xl p-6 shadow-sm hover:shadow-md/20 transition-all duration-200 flex flex-col gap-4 w-full">
          <NotificationSubscriptionsSection userId={assistant.userId} isDisabled={isDisabled} />
        </div>
      )}
    </div>
  );
};
